import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { Test } from '@app/_components/test';
import { retry, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AlertService } from '@app/_services';
import { SharedService } from '@app/_components/_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class OpsDashboardService {

	statuses: any = [
		{ value: '0', name: 'Active' },
		{ value: '2', name: 'Suspended' },
		{ value: '1', name: 'Canceled' }
	];

	TODAY_REPORT='TODAY_REPORT';
	YESTERDAY_REPORT='YESTERDAY_REPORT';
	AVG_REPORT='AVG_REPORT';

	constructor
		(
			private http: HttpClient,
			private alertService: AlertService,
			private sharedService: SharedService
		) { }

	urlEndpoint = 'ops-dashboard';

	findAll(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`).pipe();
	}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any): Observable<ApiResponse> {
		let params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		console.log('posting... ' + JSON.stringify(filters));
		return this.http.get<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}`, { params: params }).pipe();

	}

	getYieldMaxMessageDetailsByReferenceId(opsDashboardRequest: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(opsDashboardRequest));
		return this.http.post<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}/message/details`, opsDashboardRequest).pipe();
	}

	getWikiMessageDetailsByReferenceId(opsDashboardRequest: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(opsDashboardRequest));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/message/details`, opsDashboardRequest).pipe();
	}

	syncDashboardDetails(opsDashboardRequest: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(opsDashboardRequest));
		return this.http.post<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}/sync-data`, opsDashboardRequest).pipe();
	}

	getYieldMaxOpsDashboardDataForProperties(opsDashboardRequest: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(opsDashboardRequest));
		return this.http.post<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}/properties/summary`, opsDashboardRequest).pipe();
	}

	getYieldMaxOpsDashboardDataForReservations(opsDashboardRequest: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(opsDashboardRequest));
		return this.http.post<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}/reservations/summary`, opsDashboardRequest).pipe();
	}

	getWiKiOpsDashboardDataForRUReservation(opsDashboardRequest: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(opsDashboardRequest));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/ru-reservations/summary`, opsDashboardRequest).pipe();
	}

	getWiKiOpsDashboardDataForBlogs(opsDashboardRequest: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(opsDashboardRequest));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/blogs/summary`, opsDashboardRequest).pipe();
	}

	getWiKiOpsDashboardDataForRUPricing(opsDashboardRequest: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(opsDashboardRequest));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/ru-pricing/summary`, opsDashboardRequest).pipe();
	}

	getWiKiOpsDashboardDataForRUAvailability(opsDashboardRequest: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(opsDashboardRequest));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/ru-availability/summary`, opsDashboardRequest).pipe();
	}

	getWiKiOpsDashboardDataForRUProperty(opsDashboardRequest: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(opsDashboardRequest));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/ru-properties/summary`, opsDashboardRequest).pipe();
	}

	getYieldMaxOpsDashboardDataForRates(opsDashboardRequest: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(opsDashboardRequest));
		return this.http.post<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}/rates/summary`, opsDashboardRequest).pipe();
	}

	getYieldMaxOpsDashboardDataForRatesLos(opsDashboardRequest: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(opsDashboardRequest));
		return this.http.post<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}/ratesLos/summary`, opsDashboardRequest).pipe();
	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe();
	}

	getWikiOpsDashboardDataForReviews(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/reviews/summary`).pipe();
	}

	getWikiOpsDashboardDataForReviewsSent(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/reviews/sent/summary`).pipe();
	}

	getWikiOpsDashboardDataForInOutData(): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/in-out/summary`).pipe();
	}

	getWikiOpsDashboardDataForRates(opsDashboardRequest: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(opsDashboardRequest));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/rates/summary`, opsDashboardRequest).pipe();
	}

	getWikiOpsDashboardDataForRatesLos(opsDashboardRequest: any): Observable<ApiResponse> {
		console.log('posting... ' + JSON.stringify(opsDashboardRequest));
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/rateDetailsLos/summary`, opsDashboardRequest).pipe();
	}

	getHealthSummary(opsDashboardRequest: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}/health/summary`, opsDashboardRequest).pipe();
	}

	getPropertySync24h(opsDashboardRequest: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.yieldMaxApiUrl}/${this.urlEndpoint}/property-sync-24h`, opsDashboardRequest).pipe();
	}

  getReservationData(opsDashboardRequest: any): Observable<ApiResponse> {
    console.log('getReservationData... ' + JSON.stringify(opsDashboardRequest));
    return this.http.post<ApiResponse>(`${environment.apiUrl}/reports/reservations/channels`, opsDashboardRequest).pipe();
  }


	prepareParamsFromPrimeNgDataTable(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta, globalFilter: any, filters: any) {
		try {
			console.log(
				'  |  page:' + page
				+ '  |  size:' + size
				+ '  |  sortBy:' + sortBy
				+ '  |  sortOrder:' + sortOrder
				+ '  |  multiSortMeta:' + JSON.stringify(multiSortMeta)
				+ '  |  globalFilter:' + globalFilter
				+ '  |  filters:' + JSON.stringify(filters)
			);

			let params = new HttpParams();

			if (!isNaN(page)) { params = params.append('page', page); }
			if (!isNaN(size)) { params = params.append('size', size); }
			if (sortBy) { params = params.append('sort', sortBy + ',' + (sortOrder === 1 ? 'asc' : 'desc')); }
			if (multiSortMeta) {
				// if sortMode="multiple" in primeng table then multiSortMeta is used for ALL sorting (even just one column.)
				// Otherwise, single sorting is used above.
				// event.multiSortMeta:[{"field":"lastName","order":1},{"field":"firstName","order":1}]
				for (let i = 0; i < multiSortMeta.length; i++) {
					let json = JSON.parse(JSON.stringify(multiSortMeta[i]));
					params = params.append('sort', json.field + ',' + (json.order === 1 ? 'asc' : 'desc'));
				}
			}
			// globalFilter works, but did not implemnt in Spring but not hard to write custom findAll and specify certain columns to look.
			if (globalFilter) { params = params.append('filter', globalFilter); }

			// multiselect or input or whatever... these work slick.
			if (filters) {
				// key:status val:{"value":["A"],"matchMode":"in"}
				for (let i = 0, keys = Object.keys(filters), ii = keys.length; i < ii; i++) {
					console.log('key:' + keys[i] + ' val:' + JSON.stringify(filters[keys[i]]));
					params = params.append(keys[i], filters[keys[i]].value);
				}
			}
			return params;
		} catch (error) {
			console.log('prepareParamsFromPrimeNgDataTable()' + error);
		}
	}
}
